import ReferenceService from '@/general/services/ReferenceService';
import { parseEntities } from '@/shared/converters/commonConverters';
import { DateTimeFormat, parseMoment } from '@/shared/converters/dateConverters';
import RestrictedAccessRecord from '../models/RestrictedAccessRecord';

export const SCHEMA = {
  id: 'id',
  userId: 'outletUserId',
  dossierId: 'dossierId',
  outletId: 'outletId',
  outletDescription: 'outletDescription',
  externalReference: 'externalReference',
  appointmentOn: (data: any) => parseMoment(data.appointment),
  registrationNumber: 'registrationNumber',
  createdOn: (data: any) => parseMoment(data.createdOn),
  createdBy: (data: any) => ReferenceService.getUser(data.createdById),
};

export function parseRestrictedAccessRecords(data: any): Array<RestrictedAccessRecord> {
  return parseEntities(data, SCHEMA, RestrictedAccessRecord);
}